export default __webpack_public_path__ + "locales/lo-LA/ConvertDialog.json?hash=ca9084d446e5edb7bd168319a9779475";